import ModalForm from 'core/elements/modal/ModalForm'
import UsersPicklist from 'account/components/userManagement/users/UsersPicklist'
import PicklistField from 'core/components/validatedForm/DropdownField'
import React, { useState } from 'react'
import Text from 'core/elements/Text'
import { updateVirtualMachineOwner } from 'app/plugins/openstack/components/vms/actions'
import { makeStyles } from '@material-ui/styles'
import Alert from 'core/components/Alert'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { existingVmOwnerValidator } from 'core/utils/fieldValidators'

const ChangeOwnerDialog = ({ rows: vms, onClose }) => {
  const classes = useStyles()
  const vm = vms?.[0]

  const [userId, setUserId] = useState(null)
  const [error, setError] = useState(null)

  const { update, updating, error: updateError } = useUpdateAction(updateVirtualMachineOwner)

  const handleSubmit = async () => {
    setError(null)

    const body = {
      changeOwner: {
        user_id: userId,
      },
    }

    const res = await update({ id: vm?.id, body })

    if (res?.success) {
      onClose(true)
    } else {
      setError(
        res?.error?.response?.data?.forbidden?.message ||
          res?.error?.message ||
          'An error occurred while changing the owner. Please try again.',
      )
    }
  }

  return (
    <ModalForm
      title="Change Owner"
      onSubmit={handleSubmit}
      onClose={onClose}
      submitTitle="Confirm"
      maxWidth={600}
      submitting={updating}
      open
    >
      <div className={classes.container}>
        {(error || updateError?.message) && (
          <Alert variant="error" title="Error" message={error || updateError?.message} />
        )}
        {!error && (
          <Alert
            variant="primary"
            message={
              <Text variant="body2">
                <b>Note:</b> Make sure the new owner is within the same tenant and has enough
                resources (CPU, RAM, storage) in their quota before confirming.
              </Text>
            }
          />
        )}
        <div className={classes.picklist}>
          <PicklistField
            id="users"
            name="user"
            DropdownComponent={UsersPicklist}
            value={userId}
            validations={[existingVmOwnerValidator(vm?.user_id)]}
            onChange={(value) => setUserId(value)}
            required
          />
        </div>
      </div>
    </ModalForm>
  )
}

export default ChangeOwnerDialog

const useStyles = makeStyles(() => ({
  container: {
    display: 'grid',
    gridAutoFlow: 'columns',
    gap: 16,
  },
  picklist: {
    '& .dropdownInputFrame': {
      width: '350px',
    },
    '& .dropdownMenuWithSearch': {
      minWidth: '385px',
    },
  },
}))
